import { UnitConvertible } from '@app/shared/units/base/unit-convertible';
import { lengthFactors } from '@app/shared/units/length/length-factors';
import { LengthUnit } from '@app/shared/units/length/length-unit.enum';

export class Length extends UnitConvertible<LengthUnit> {
  protected factors = lengthFactors;
}
